// SharedComponents.js
import HeroSwiper from '/src/components/ContentCreator/Hero/HeroSwiper.vue';
import CardsOne from '/src/components/ContentCreator/Cards/CardsOne.vue';
import CardsTwo from '/src/components/ContentCreator/Cards/CardsTwo.vue';

import FeatureTriple from '/src/components/ContentCreator/FeatureHighlight/FeatureTriple.vue';
import FeatureSingle from '/src/components/ContentCreator/FeatureHighlight/FeatureSingle.vue';
import FeatureDouble from '/src/components/ContentCreator/FeatureHighlight/FeatureDouble.vue';
import SimpleRowNuggets from '/src/components/ContentCreator/InfoNugget/SimpleRowNuggets.vue';
import CourierPricing from '/src/components/ContentCreator/Functional/CourierPricing.vue';
import NotaryPricing from '/src/components/ContentCreator/Functional/NotaryPricing.vue';
import CourierEstimate from '/src/components/ContentCreator/Functional/CourierEstimate.vue';
import ServiceComparison from '/src/components/ContentCreator/FeatureHighlight/ServiceComparison.vue';
import BlankCanvas from '/src/components/ContentCreator/Misc/BlankCanvas.vue';
import CallToAction from '/src/components/ContentCreator/Misc/CallToAction.vue';
import FAQ from '/src/components/ContentCreator/Functional/FAQ.vue';
import FAQ2 from '/src/components/ContentCreator/Functional/FAQ2.vue';
import ApostillePricing from '/src/components/ContentCreator/Functional/ApostillePricing.vue';
import Quote from '/src/components/ContentCreator/Misc/Quote.vue';
import Steps from '/src/components/ContentCreator/InfoNugget/Steps.vue';
import FieldInspectionEstimate from '/src/components/ContentCreator/Functional/FieldInspectionEstimate.vue';
import InspectionPricing from '/src/components/ContentCreator/Functional/InspectionPricing.vue';
import FeatureCloud from '/src/components/ContentCreator/InfoNugget/FeatureCloud.vue';
import InspectionFeatureCloud from '/src/components/ContentCreator/Functional/InspectionFeatureCloud.vue';
import FeatureBlocks from '/src/components/ContentCreator/FeatureHighlight/FeatureBlocks.vue';
import InspectionFeatures from '/src/components/ContentCreator/Functional/InspectionFeatures.vue';
import ContactForm from '/src/components/ContentCreator/Functional/ContactForm.vue';
import NotaryQ from '/src/components/ContentCreator/Functional/NotaryQ.vue';
import SimpleIconHero from '/src/components/ContentCreator/Hero/SimpleIconHero.vue';
import NotaryPricingTeaser from '/src/components/ContentCreator/Functional/NotaryPricingTeaser.vue';
import SimpleRowNuggets2 from '/src/components/ContentCreator/InfoNugget/SimpleRowNuggets2.vue';
import MobileNotaryPricingTeaser from '/src/components/ContentCreator/Functional/MobileNotaryPricingTeaser.vue';
import MobileNotaryEstimate from '/src/components/ContentCreator/Functional/MobileNotaryEstimate.vue';

import MobileNotaryFeeSchedule from '/src/components/ContentCreator/Functional/MobileNotaryFeeSchedule.vue';
import NotaryFeeSchedule from '/src/components/ContentCreator/Functional/NotaryFeeSchedule.vue';
import Checkout from '/src/components/ContentCreator/Functional/Checkout.vue';
// ... add more components here

const SharedComponents = {
    HeroSwiper,
    FeatureTriple,
    FeatureSingle,
    CardsOne,
    FeatureDouble,
    SimpleRowNuggets,
    CourierPricing,
    CourierEstimate,
    ServiceComparison,
    BlankCanvas,
    CallToAction,
    FAQ,
    FAQ2,
    ApostillePricing,
    Quote,
    Steps,
    FieldInspectionEstimate,
    InspectionPricing,
    FeatureCloud,
    InspectionFeatureCloud,
    FeatureBlocks,
    InspectionFeatures,
    ContactForm,
    NotaryQ,
    SimpleIconHero,
    CardsTwo,
    NotaryPricingTeaser,
    NotaryPricing,
    SimpleRowNuggets2,
    NotaryFeeSchedule,
    MobileNotaryPricingTeaser,
    MobileNotaryEstimate,
    MobileNotaryFeeSchedule,
    Checkout
    // ... add more components here
};

export default SharedComponents;
